<script lang="ts">
    import {Flex} from 'shared/layouts';
    import {createEventDispatcher} from 'svelte';
    import KpButton from 'shared/ui-widgets/button/KpButton.svelte';
    import type * as XLSX from 'xlsx';

    export let workSheets: Record<string, XLSX.WorkSheet>;
    export let activeSheetName: string;

    const dispatch = createEventDispatcher<{ 'worksheet-change': string }>();

    $: sheetNames = Object.keys(workSheets);
</script>

{#if sheetNames.length > 1}
    <div class="worksheet-selector-toolbar">
        <Flex direction="row" rowGap="s" columnGap="sm" wrap="wrap">
            {#each sheetNames as sheetName (sheetName)}
                <KpButton buttonStyle={activeSheetName === sheetName ? 'brand-orange' : 'default'}
                          on:click={() => dispatch('worksheet-change', sheetName)}>

                    {sheetName}
                </KpButton>
            {/each}
        </Flex>
    </div>
{/if}

<style lang="less">
    @import (reference) "src/features/media-viewer/media-viewer.variables.less";
    @import (reference) "styles/portaro-erp.less";

    .worksheet-selector-toolbar {
        width: 100%;
        border-top: 1px solid var(--viewer-default-border);
        background-color: var(--viewer-bg);
        padding: @spacing-m @spacing-l;
    }
</style>